import React from 'react';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';

interface CustomButtonProps extends ButtonProps {
  text?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  children,
  className = '',
  type = 'button',
  variant = 'contained',
  color = 'primary',
  ...props
}) => {
  return (
    <Button type={type} className={className} variant={variant} color={color} {...props}>
      {text ?? children}
    </Button>
  );
};

export default CustomButton;
